import "leaflet/dist/leaflet.css";
import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./Layout";
import { AdminRoute } from "./pages/AdminRoute"; // the wrapper above
import { GuestRoute } from "./pages/GuestRoute";
import Login from "./pages/Login";

import { useAuth } from "./context/useAuth";

const Admin = lazy(() => import("./pages/Admin"));
const Contact = lazy(() => import("./pages/Contact"));
const Home = lazy(() => import("./pages/Home"));
const ManageData = lazy(() => import("./pages/ManageData"));
const MyProfile = lazy(() => import("./pages/MyProfile"));
const Support = lazy(() => import("./pages/Support"));
const Tools = lazy(() => import("./pages/Tools"));
const Upload = lazy(() => import("./pages/Upload"));

function App() {
  const { isLoggedIn, isGuest, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen w-full">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <React.Fragment>
      {!isLoggedIn && !isGuest ? (
        <div className="flex justify-center h-screen w-full">
          <Login />{" "}
        </div>
      ) : (
        <Suspense
          fallback={
            <div className="flex justify-center items-center h-screen w-full">
              <div>Loading...</div>
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="upload" element={<Upload />} />
              <Route path="manage-data" element={<ManageData />} />
              <Route path="tools" element={<Tools />} />
              <Route path="contact" element={<Contact />} />
              <Route path="support" element={<Support />} />
              <Route
                path="profile"
                element={
                  <GuestRoute>
                    <MyProfile />
                  </GuestRoute>
                }
              />

              <Route
                path="admin"
                element={
                  <AdminRoute>
                    <Admin />
                  </AdminRoute>
                }
              />
            </Route>
          </Routes>
        </Suspense>
      )}
    </React.Fragment>
  );
}

export default App;
